export const COPY = {
    OPT1: "Keywords",
    OPT2: "Outcomes",
    KEYWORDSDESC:
        "Search for learning objects by organization, user, or keyword/phrase.",
    OUTCOMESDESC: "Search for learning objects by mapped standard outcomes.",
};
